import React from 'react';
import { SlDrawer } from '@shoelace-style/shoelace/dist/react';
import useToast from './utils/useToast';
import useClipboard from './utils/useClipboard';

function PreviewDrawer({ open, row, onClose }) {
  const toast = useToast();
  const copyToClipboard = useClipboard();
  if (!row) return null;

  const renderPreview = () => {
    return (
      <div className="mx-auto my-6 w-[351px] h-[664px] rounded-[2rem] border-[10px] border-black shadow-xl relative overflow-hidden">
        <iframe
          src={row.html_url}
          title="HTML Preview"
          className="w-full h-full rounded-lg"
          frameBorder="0"
          loading="lazy"
          scrolling="no"
          style={{
            border: "none",
            height: "100%",
            width: "100%",
          }}
        />
      </div>
    );
  };

  const handleCopy = () => {
    copyToClipboard(row.html_url, toast);
  };

  return (
    <SlDrawer open={open} onSlAfterHide={onClose} className="webview-upload-drawer z-50" style={{ '--size': '50vw' }}>
      <div className="flex items-center justify-between border-b border-gray-200 pb-4">
        <h2 className="text-2xl font-bold text-gray-800">{row.creative_name}</h2>
      </div>
      {renderPreview()}
      <div className="flex flex-col gap-2 items-center justify-center">
        <label className="text-gray-600 font-medium">
          {row.type === 'video' ? 'Video URL' : 'HTML URL'}
        </label>
        <div className="flex items-center gap-2">
          <span className="truncate px-2 py-1">
            {row.html_url}
          </span>
          <button
            className="px-3 py-1 rounded-lg border border-green-500 text-green-500 hover:bg-green-50"
            onClick={handleCopy}
          >
            Copy
          </button>
        </div>
      </div>
    </SlDrawer>
  );
}

export default PreviewDrawer;
